import styled from 'styled-components';

export default styled.div`
   position: absolute;
   top: 78px;
   left: 12px;
   width: 224px;
   height: 90px;
   text-align: center;
   overflow: hidden;
   
   p {
     width: 100%;
     height: 48px;
     font-size: 36px;
     line-height: 30px;
     white-space: nowrap;
   }
`;
